import styled from '@emotion/styled'
import {
    TheWestLiveLogo,
    PRIMARY_FILL_CLASS,
} from '../../../logos/TheWestLiveLogo/TheWestLiveLogo'
import { TheWestLivePlayer } from '../TheWestLivePlayer/TheWestLivePlayer'
import { colors } from '../../../__styling/settings/colors'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'

export const StyledWestLiveInArticleBannerContainer = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        height: calcRem(120),
        width: '100%',
        maxWidth: 454,
        margin: '0 auto',
        marginBottom: calcRem(theme.margins.md),
        padding: `0 ${calcRem(theme.margins.md)}`,
        position: 'relative',
        overflow: 'hidden',
    }),
)

export const StyledWestLiveInArticleBannerLogoContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
})

export const StyledWestLiveInArticleLogo = styled(TheWestLiveLogo)(
    ({ theme }) => ({
        width: calcRem(100),
        height: calcRem(40),

        [`.${PRIMARY_FILL_CLASS}`]: themedValue(theme, {
            perthnow: { fill: colors.black },
            fallback: undefined,
        }),
    }),
)

export const StyledWestLiveInArticlePlayer = styled(TheWestLivePlayer)(
    ({ theme }) => ({
        padding: `${calcRem(theme.margins.sm)} 0`,
    }),
)

export const StyledWestLiveInArticleBannerText = styled('p')({
    padding: 0,
    paddingLeft: calcRem(10),
    margin: `0 ${calcRem(10)}`,
    fontSize: calcRem(16),
    borderLeft: `1px solid ${colors.black}`,
})
